module.exports = __webpack_public_path__ + "images/flyer3-1f80a7cbe9e517be5ef92c9b6adbe62a.jpg";